import Document from "@tiptap/extension-document";
import Gapcursor from "@tiptap/extension-gapcursor";
import HardBreak from "@tiptap/extension-hard-break";
import History from "@tiptap/extension-history";
import Link from "@tiptap/extension-link";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";

export const extensions = [
  Document,
  Paragraph,
  Text,
  History,
  Gapcursor,
  HardBreak,
];

export const extensionsWithLink = [
  ...extensions,
  Link.configure({
    autolink: true,
    openOnClick: true,
    linkOnPaste: true,
    defaultProtocol: "https",
    HTMLAttributes: {
      target: "_blank",
      rel: "noopener noreferrer",
    },
  }),
];
